/** @format */

import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../app/hooks";
import {
  selectIsLoading,
  selectStage,
  setShowModal,
  setStage,
} from "./contentEditorSlice";
import BLSpinner from "../../assets/animations/BLSpinner/BLSpinner";
import { ReactComponent as ExclamationCircle } from "bootstrap-icons/icons/exclamation-circle.svg";
import { useTranslation } from "react-i18next";

type Props = {
  maxStages?: number;
  warningMsg?: string;
};

const ContentEditorFooter: React.FC<Props> = ({
  maxStages = 1,
  warningMsg: msg,
}) => {
  const isLoading = useAppSelector(selectIsLoading());
  const currentStage = useAppSelector(selectStage());
  const dispatch = useDispatch();
  const { t: _ } = useTranslation();

  return (
    <Modal.Footer className="footer">
      {msg && (
        <p className="text-danger me-auto">
          <ExclamationCircle
            className="me-2"
            style={{ width: "20px", height: "20px", verticalAlign: "-0.25em" }}
          />
          &nbsp;{msg}
        </p>
      )}

      {currentStage === 1 || maxStages === 1 ? (
        <Button
          variant="outline-editing"
          disabled={isLoading}
          onClick={() => dispatch(setShowModal(false))}
        >
          {_("Cancel")}
        </Button>
      ) : (
        <Button
          variant="outline-editing"
          onClick={() => dispatch(setStage(currentStage - 1))}
        >
          {_("Back")}
        </Button>
      )}
      {currentStage === maxStages || maxStages === 1 ? (
        isLoading ? (
          <Button variant={"outline-editing"} disabled>
            <BLSpinner />
          </Button>
        ) : (
          <Button variant="editing" type="submit">
            {_("Save")}
          </Button>
        )
      ) : (
        <Button variant="editing" type="submit">
          {_("Next")}
        </Button>
      )}
    </Modal.Footer>
  );
};

export default ContentEditorFooter;
